import {
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ClientService } from 'src/app/pages/client-management/services/client.service';
import { PageRequest } from 'src/app/shared/models/common';
import { SearchSelectComponent } from '../search-select/search-select.component';

@Component({
  selector: 'app-client-deposit-search-select',
  templateUrl: './client-deposit-search-select.component.html',
  styleUrls: ['./client-deposit-search-select.component.css'],
})
export class ClientDepositSearchSelectComponent implements OnInit, OnChanges {
  currentScrollPosition = 0;
  @ViewChild(SearchSelectComponent) childComponent: SearchSelectComponent;
  @Input() showDefaultListValue: boolean = false;
  @Input() defaultSelected: any;
  @Input() control: FormControl | string;
  @Input() areaId: number = 0;
  @Input() branchId: number = 0;
  @Input() type: 'client' | 'server' = 'server';
  @Input() clientData;
  @Output() emitSelectedVal: EventEmitter<any> = new EventEmitter();

  public clientLabel = $localize`:@@client:Client`;
  public endpoint: string = this.clientService.searchClientByParamEndpoint();
  public clientKeyValue = {
    key: ['clientName'],
    value: 'id',
  };
  public pageRequest: PageRequest = {
    page: 0,
    pageSize: 10,
    state: 'APPROVED',
    sortField: 'last_update_time',
    sortOrder: 'DESC',
    filter:''
  };

  constructor(
    private clientService: ClientService,
    private ngZone: NgZone,
    private http: HttpClient,
  ) {}
  private clientsRequested = false;

  ngOnInit(): void {
    // If area/branch inputs are bound, ngOnChanges runs first and loads the
    // list against the deposit endpoint. Only load here as a fallback when
    // that didn't happen, to avoid a duplicate initial request.
    if (!this.clientsRequested) {
      this.loadClients();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['branchId'] || changes['areaId']) {
      this.branchId = changes['branchId']
        ? changes['branchId'].currentValue
        : this.branchId;
      this.areaId = changes['areaId']
        ? changes['areaId'].currentValue
        : this.areaId;
      const param: any = {
        ...(this.areaId && { areaId: this.areaId }),
        ...(this.branchId && { branchId: this.branchId }),
      };
      const queryParam = new URLSearchParams(param).toString();
      this.endpoint =
        this.clientService.searchDepositClientByParamEndpoint(queryParam);
      // (Re)load the deposit-client list whenever the area/branch filter
      // changes so the dropdown always reflects the current scope.
      this.loadClients();
    }
  }

  // Load the full deposit-client list (endpoint caps at 500) and normalise the
  // display name into `clientName`/`name`, since the API returns
  // `first_name`/`last_name`. This lets the list show on open and be searched
  // locally on every open.
  private loadClients() {
    this.clientsRequested = true;
    this.http.get<any>(this.endpoint).subscribe((res) => {
      this.clientData = (res?.data ?? []).map((client: any) => {
        const fullName =
          client.clientName ??
          `${client.first_name ?? ''} ${client.last_name ?? ''}`.trim();
        return {
          ...client,
          clientName: fullName,
          name: fullName,
        };
      });
    });
  }

  getClients() {
    this.loadClients();
  }

  emitSelected(value: { id: any; clientName: string; }) {
    this.emitSelectedVal.emit(value);
  }

  loadAllOnScroll(event) {
    if(this.type === 'server')
      return;

    // Check if scrolled to the bottom
    if (Math.floor(event.target.scrollTop) === event.target.scrollHeight - event.target.clientHeight - 1) {
      this.pageRequest.page++;
      //this.childComponent.selectElem.panel.nativeElement.scrollTop = this.currentScrollPosition;
      this.setScrollPosition(event.target.scrollTop)
      
      this.getClients();
    }
  }

  setScrollPosition(scrollTop): void {
    if (!this.childComponent || !this.childComponent.selectElem || !this.childComponent.selectElem.panel) {
      return;
    }

    // Store the current scroll position
    this.currentScrollPosition = scrollTop === 0 ? this.currentScrollPosition : scrollTop;
  }
}
